import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@mui/material";

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = "Delete Item",
  message = "Are you sure you want to delete this item?",
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle style={{ background: "#1976d2", color: "white" }}>
        {title}
      </DialogTitle>
      <DialogContent style={{ display: "flex", alignItems: "center" }}>
        {message}
      </DialogContent>
      <DialogActions>
        <div className="mb-1">
          <Button
            style={{ background: "#f1f1f1", color: "black" }}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            className="ml-2"
            variant="contained"
            style={{ background: "#1976D2", color: "white" }}
            onClick={onConfirm}
          >
            Delete
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
